import { atom } from 'jotai'

/**
 * Definition of a single permission declared by a page via `usePagePermissions`.
 */
export type PagePermissionDefinition = {
  /** The actual permission string checked against `user.permissions[]` */
  permission: string
  /** Human-readable description shown in the testing panel */
  description: string
}

/**
 * Jotai atom storing the current page's permission declarations.
 * Populated by `usePagePermissions` on mount, cleared on unmount.
 *
 * Key = camelCase logical name (e.g. `canDoThat`)
 * Value = definition containing the real permission string and a description
 */
export const pagePermissionsAtom = atom<Record<string, PagePermissionDefinition>>({})
